import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BvdIdValidationResult } from '@models/bvd-id-validation.model';

@Injectable({
  providedIn: 'root',
})
export class ValidateBvdIdService {
  constructor(private http: HttpClient) {}

  public validateBvdNumbers$(searchStrategyId: number, bvdIds: string, databases: any): Observable<BvdIdValidationResult[]> {
    return this.http.post<BvdIdValidationResult[]>(`/api/study/ValidateBvdIds`, { searchStrategyId, databases, bvdIds });
  }

  public replaceBvdNumbers(bvdIds_old: string, bvdValResult: BvdIdValidationResult[]): string {
    bvdValResult.forEach((ri) => {
      bvdIds_old = bvdIds_old.replace(ri.bvdIdOld, ri.bvdIdNew);
    });
    return bvdIds_old;
  }

  getBvdValidationMsg(result: BvdIdValidationResult[]): string {
    let msg = '';
    if (result.length > 1) {
      msg += `<ul>`;
      result.forEach((val) => {
        msg += `<li>${val.bvdIdOld} is the previous ID of ${val.companyName}.  The current BVD ID is ${val.bvdIdNew} </li>`;
      });
      msg += `</ul><br />  Do you want to continue the selection of these companies?`;
    } else {
      msg = `${result[0].bvdIdOld} is the previous ID of ${result[0].companyName}.  The current BVD ID is ${result[0].bvdIdNew} <br /> Do you want to continue the selection of this company?`;
    }
    return msg;
  }
}
